/**
 * Created by rathompson on 12/14/23
 * File: AcquisitionRequestBanner.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import { useContext } from 'react'
import GlobalContext from '../../../common/context/GlobalContext'
import { useModal } from '../../../common/components/modal/Modal'
import SubtenantAcquisitionModal from './SubtenantAcquisitionModal'
import { NotificationImportantIcon } from '@panwds/icons'
import { Body, Button } from '@panwds/react-ui'
import {
  ACQUISITION_BANNER_TEMPLATE,
  BUTTON_VIEW_REQUEST
} from '../../constants/LabelConstants'
import StringTemplate from '../../../common/utils/StringTemplate'

const AcquisitionRequestBanner: VFC<{ tsg_id: string, acquisition: any }> = ({ tsg_id, acquisition }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { sgKeyBy } = treeReducer

  const subtenantAcquisitionModal = useModal(SubtenantAcquisitionModal)

  const tenantName = sgKeyBy?.[tsg_id]?.display_name || tsg_id

  return (
    <div className='cm-flex cm-justify-between cm-rounded cm-bg-blue-100 dark:cm-bg-blue-800 cm-w-full cm-p-2'>
      <div className='cm-flex cm-gap-2 cm-items-center dark:cm-text-dark-bg'>
        <NotificationImportantIcon className='cm-text-primary'/>
        <Body>{StringTemplate(ACQUISITION_BANNER_TEMPLATE, [tenantName])}</Body>
      </div>
      <Button
        appearance='primary'
        onClick={() => subtenantAcquisitionModal.openModal({ acquisition } as any)}
        size='sm'
      >{BUTTON_VIEW_REQUEST}</Button>
    </div>
  )
}

export default AcquisitionRequestBanner
